import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-sanity/dist/experimental/client-components/live.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/dove-siamo/[slug]/_components/ContactButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/dove-siamo/[slug]/_components/LocationMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/dove-siamo/[slug]/_components/StickyActionsBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/test/FilterMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/test/FilterMenuMobile.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/test/InfiniteScroll.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/test/ProductCard.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/test/SelectOrder.tsx");
